
import React, { useEffect, useRef, useState } from 'react';
import { EditPageHeader } from './EditPageHeader';
import { Grid, GRID_COL_INDEX_ATTRIBUTE, GridColumn } from '@progress/kendo-react-grid';
import { DropdownCell, SingleDropDownCell } from '../framework/forms/helpercomponents/CustomGridCells/DropdownCell';
import { toast } from 'react-toastify';
import * as API from "../framework/API/api";
import { utility } from '../framework/utility/utilityProvider';
import { COLUMNSTYPE, ENTITYNAME, LOCALSTORAGE_KEY, MEDIA_TRANSMISSION } from '../framework/constant/constant';
import { CellRender, RowRender } from '../modules/Segment/renderers';
import { useTranslation } from '../locale/useTranslation';
import PreferenceRoundButton from '../framework/forms/helpercomponents/buttons/PreferenceRoundButton';
import { UserPreference } from '../modules/userPreference/UserPreference';
import { arrayEnumCell } from '../framework/forms/helpercomponents/CustomGridCells/PlatformCell';
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from '../framework/forms/helpercomponents/CustomGridCells/DateCell';
import MyStatusCell from './MyStatusCell';
import { ArrayCell } from '../framework/forms/helpercomponents/CustomGridCells/ArrayCell';
import { CheckboxCell } from '../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell';
import { ImageCell } from '../framework/forms/helpercomponents/CustomGridCells/ImageCell';
import { Loader } from '../framework/forms/helpercomponents/Loader';
import { getter, Icon } from '@progress/kendo-react-common';
import { myTimeCellMilliseconds } from '../framework/forms/helpercomponents/inline grid cell/MyTimeCellInMillisconds';
import BossDialog from './BossDialog';
import { getSelectedState, useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';
import { MediaMamAssetColumns } from '../framework/utility/customColumns';
import CollectionSelection from '../framework/forms/CollectionSelection';
import { TimePickerWithFormat } from '../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import MyMultiSelect from './MyMultiSelect';
import ActionButton from '../framework/forms/helpercomponents/buttons/ActionButton';
import { ConfirmAlert } from '../ConfirmAlert';

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const EDIT_FIELD = 'inEdit';
const idGetter = getter(DATA_ITEM_KEY);

const UpdateMultipleEpisodeDialog = (props) => {

    const { selectedEpisode, setSelectedEpisode, refresh, closeForm } = props;

    const [updatedDataItemIds, setUpdatedDataItemIds] = useState([]);
    const [genres, setGenres] = useState([]);
    const [language, setLanguage] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [pgRatings, setPgRatings] = useState([]);
    const [categories, setCategories] = useState([]);
    const seletedEpisodeRef = useRef([]);

    const lang = useTranslation();
    const [showPreferences, setShowPreferences] = useState(false);
    const [showMamAssetCollectionSelection, setShowMamAssetCollection] = useState(false);
    const [dataColumns, setDataColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedState, setSelectedState] = useState({});
    const blankDataItem = {
        Title: "",
        EpisodeTitle: "",
        Duration: "00:00:00:00",
        Genres: [],
        SubGenres: [],
        Synopsis: "",
    };
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        loadCombo();
        loadMetaData();
        loadColumns();
    }, []);

    const loadColumns = async () => {
        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
        let columns = await API.getFormData(ENTITYNAME.MediaEpisodeMultiEdit, currentUserId) ?? [];
        setDataColumns(columns);
    }

    const loadCombo = async () => {
        let genreRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
        setGenres(genreRes.data);
        let languagesRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
        setLanguages(languagesRes.data);
        let pgRatingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
        setPgRatings(pgRatingRes.data);
        let categoriesRes = await API.getDataLookup(ENTITYNAME.ContentCategory, { sort: { Name: 1 } });
        setCategories(categoriesRes.data);
    }

    const loadMetaData = async () => {
        setIsLoading(true);
        let defaultLang = null;
        if (selectedEpisode.length > 0) {
            let langRes = await API.getData(ENTITYNAME.Language);
            if (langRes.success && langRes.data.length > 0) {
                defaultLang = utility.getDefaultItem(langRes.data);
                setLanguage(defaultLang);
            } else {
                toast.error('Couldn\'t get default language', {
                    position: toast.POSITION.TOP_RIGHT,
                })
                multipleUpdateFormClose();
                return;
            }
            let res = await API.getMetaDataFromMediaEpisode(selectedEpisode.map(x => x.SID));
            if (res.success) {
                const metaData = res.data;
                setSelectedEpisode(
                    selectedEpisode.map(x => {
                        let metaDataAttached = metaData?.find(m => m.MediaEpisodeSID == x.SID);
                        if (metaDataAttached) {
                            let synop = metaDataAttached.Synopsis?.filter(s => s?.Language?._id == defaultLang._id);
                            if (synop?.length > 0) {
                                let item = {
                                    ...x,
                                    MediaEpisode_id: metaDataAttached.MediaEpisode_id,
                                    MediaEpisodeSID: metaDataAttached.MediaEpisodeSID,
                                    metaDataId: metaDataAttached._id,
                                    Synopsis: metaDataAttached.Synopsis,
                                    synopsis: synop[0].Synopsis,
                                    dynamicField: metaDataAttached.dynamicField,
                                    CastAndCrew: metaDataAttached.CastAndCrew,
                                    PGRating: metaDataAttached.PGRating,
                                    Languages: metaDataAttached.Languages,
                                    Categories: metaDataAttached.Categories,
                                    MamID: metaDataAttached.MamID ?? ""
                                }

                                //CAST & CREW HANDLING
                                if (metaDataAttached.CastAndCrew && metaDataAttached.CastAndCrew.length > 0) {
                                    metaDataAttached.CastAndCrew.map((y) => {
                                        item[y.CastType.Description] = y.Name
                                    })
                                }
                                return item;
                            } else {
                                let obj = {
                                    ...x,
                                    MediaEpisode_id: metaDataAttached.MediaEpisode_id,
                                    MediaEpisodeSID: metaDataAttached.MediaEpisodeSID,
                                    metaDataId: metaDataAttached._id,
                                    Synopsis: [],
                                    synopsis: "",
                                    dynamicField: metaDataAttached.dynamicField,
                                    CastAndCrew: metaDataAttached.CastAndCrew,
                                    PGRating: metaDataAttached.PGRating,
                                    Languages: metaDataAttached.Languages,
                                    Categories: metaDataAttached.Categories,
                                    MamID: metaDataAttached.MamID ?? ""
                                }

                                //CAST & CREW HANDLING
                                if (metaDataAttached.CastAndCrew && metaDataAttached.CastAndCrew.length > 0) {
                                    metaDataAttached.CastAndCrew.map((y) => {
                                        obj[y.CastType.Description] = y.Name
                                    })
                                }
                                return obj;
                            }
                        }
                        return { ...x, MediaEpisode_id: x.SID, MediaEpisodeSID: x.SID, metaDataId: null, synopsis: "", dynamicField: {}, Languages: [], Categories: [], PGRating: {}, MamID: "" };
                    })
                );
            } else {
                toast.error(res.message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                multipleUpdateFormClose();
            }
        }
        setIsLoading(false);
    }

    const multipleUpdateFormClose = () => {
        closeForm();
        setUpdatedDataItemIds([]);
    }

    const enterEdit = (dataItem, field) => {
        const newData = selectedEpisode.map(item => ({
            ...item,
            [EDIT_FIELD]: (item._id == dataItem._id && item.Sequence === dataItem.Sequence) ? field : undefined
        }));
        setSelectedEpisode(newData);
    };

    const exitEdit = () => {
        const newData = selectedEpisode.map(item => ({
            ...item,
            [EDIT_FIELD]: undefined
        }));
        setSelectedEpisode(newData);
    };

    const customCellRender = (td, props) => <CellRender originalProps={props} td={td} enterEdit={enterEdit} editField={EDIT_FIELD} />;

    const customRowRender = (tr, props) => <RowRender originalProps={props} tr={tr} exitEdit={exitEdit} editField={EDIT_FIELD} />;

    const itemChange = (event) => {
        let field = event.field || '';
        if (field == 'Duration') {
            event.dataItem[field] = utility.convertStringWithFramesToMilliseconds(event.value);
        } else {
            if (field.includes('.')) {
                let keys = field.split('.');
                keys.length == 2 ? event.dataItem[keys[0]][keys[1]] = event.value : event.dataItem[keys[0]] = event.value
            } else {
                event.dataItem[field] = event.value;
            }
        }

        let newData = selectedEpisode.map(item => {
            if (item._id === event.dataItem._id) {
                return event.dataItem;
            }
            return item;
        });
        if (!updatedDataItemIds.includes(event.dataItem._id)) {
            setUpdatedDataItemIds([...updatedDataItemIds, event.dataItem._id]);
        }
        setSelectedEpisode(newData);
    };

    const handleMultipleUpdateSave = async () => {
        if (updatedDataItemIds.length == 0) {
            toast.success('Nothing to update', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } else {
            // DELETE UN-WANTED KEY FROM DATA BEFORE SENDING TO API
            let dataToUpdate = selectedEpisode.filter(x => updatedDataItemIds.includes(x._id)).map(d => {

                let item = { ...d };

                //REMOVE METADATA KEYS
                delete item[EDIT_FIELD];
                delete item.metaDataId;
                delete item.MediaEpisode_id;
                delete item.MediaEpisodeSID;
                delete item.synopsis;
                delete item.Synopsis;
                delete item.dynamicField;
                if (item.CastAndCrew && item.CastAndCrew.length > 0) {
                    item.CastAndCrew.map((y) => {
                        delete item[y.CastType.Description];
                    })
                }
                delete item.CastAndCrew;
                delete item.Languages;
                delete item.PGRating;
                delete item.Categories;
                delete item.MamID;

                return item;
            });

            // send data in chunks of 50 to api
            for (let i = 0; i < dataToUpdate.length; i += 50) {
                let media = dataToUpdate.slice(i, i + 50);
                let res = await API.bulkUpdate(ENTITYNAME.MediaEpisode, media);
                if (!res.success) {
                    toast.error(res.message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    toast.error('Some data not updated', {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setUpdatedDataItemIds(updatedDataItemIds.filter(x => !media.map(x => x._id).includes(x)));
                }
            }
            toast.success('Data updated successfully', { position: toast.POSITION.TOP_RIGHT });
        }
        await handleMultipleEditMetaData();
    }

    const handleMultipleEditMetaData = async () => {
        if (updatedDataItemIds.length == 0) {
            toast.success('Nothing to update', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } else {

            let dataToUpdate = selectedEpisode.filter(x => updatedDataItemIds.includes(x._id)).map(d => {
                let item = {};
                let otherSynopsis = d.Synopsis?.filter(s => s.Language._id != language._id);
                if (otherSynopsis?.length > 0) {
                    item = {
                        _id: d.metaDataId,
                        MediaEpisode_id: d.MediaEpisode_id,
                        MediaEpisodeSID: d.MediaEpisodeSID,
                        Synopsis: [...otherSynopsis, { Language: language, Synopsis: d.synopsis }],
                        dynamicField: d.dynamicField,
                        CastAndCrew: d.CastAndCrew && d.CastAndCrew.length > 0 ? d.CastAndCrew.map((x) => {
                            return { ...x, Name: d[x.CastType.Description] }
                        }) : [],
                        Languages: d.Languages && d.Languages.length > 0 ? d.Languages.map(x => { return { ...x, Description: x.Description } }) : [],
                        PGRating: d.PGRating && Object.keys(d.PGRating).length > 0 ? { _id: d.PGRating._id, Description: d.PGRating.Description } : {},
                        Categories: d.Categories && d.Categories.length > 0 ? d.Categories.map(x => { return { _id: x._id, Name: x.Name } }) : [],
                        MamID: d.MamID ?? '',
                    };
                } else {
                    item = {
                        _id: d.metaDataId,
                        MediaEpisode_id: d.MediaEpisode_id,
                        MediaEpisodeSID: d.MediaEpisodeSID,
                        Synopsis: [{ Language: language, Synopsis: d.synopsis }],
                        dynamicField: d.dynamicField,
                        CastAndCrew: d.CastAndCrew && d.CastAndCrew.length > 0 ? d.CastAndCrew.map((x) => {
                            return { ...x, Name: d[x.CastType.Description] }
                        }) : [],
                        Languages: d.Languages && d.Languages.length > 0 ? d.Languages.map(x => { return { ...x, Description: x.Description } }) : [],
                        PGRating: d.PGRating && Object.keys(d.PGRating).length > 0 ? { _id: d.PGRating._id, Description: d.PGRating.Description } : {},
                        Categories: d.Categories && d.Categories.length > 0 ? d.Categories.map(x => { return { _id: x._id, Name: x.Name } }) : [],
                        MamID: d.MamID ?? '',
                    };
                }
                return item;
            });

            // send data in chunks of 50 to api
            for (let i = 0; i < dataToUpdate.length; i += 50) {
                let media = dataToUpdate.slice(i, i + 50);
                let res = await API.bulkUpdate(ENTITYNAME.MediaEpisodeMetaData, media);
                if (!res.success) {
                    toast.error(res.message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    toast.error('Some data not updated', {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setUpdatedDataItemIds(updatedDataItemIds.filter(x => !media.map(x => x._id).includes(x)));
                }
            }

            //CALL SYNC MAM ID FUNCTION
            let mediaData = selectedEpisode.filter((x) => updatedDataItemIds.includes(x._id)).filter((x) => x.MamID && x?.MamID?.toString().length > 0).map((z) => ({ MamID: z.MamID, AssetId: z.AssetId }));
            console.log(mediaData)
            await onSyncMAMAsset(mediaData);


            toast.success('Meta Data updated successfully', { position: toast.POSITION.TOP_RIGHT });
        }
        onClose();
    }

    const onMultiDropDownChange = (event, dataItem, field, textField = "Description") => {
        setSelectedEpisode(selectedEpisode.map(x => x._id == dataItem._id ? { ...x, [field]: event.value.map(e => ({ _id: e._id, [textField]: e?.[textField] })) } : x));
        if (!updatedDataItemIds.includes(dataItem._id)) {
            setUpdatedDataItemIds([...updatedDataItemIds, dataItem._id]);
        }
    }

    let timeOut;
    const handleColumnResize = (event) => {
        try {
            if (event.index == 0) return;
            if (dataColumns == undefined || dataColumns.length == 0 || dataColumns.length < event.index) return;

            let column = dataColumns[event.index];
            let payload = {
                entityName: column?.entityName,
                name: column?.name,
                width: event.newWidth
            };
            clearTimeout(timeOut);
            timeOut = setTimeout(() => {
                API.updateUserPreferenceColumnWidth(payload);
            }, 700);
        } catch (error) {
            console.error("Error handling column resize:", error);
        }
    };

    const onDropDownChange = (event, dataItem, field, onlyID = false) => {
        const selected = event.value;
        setSelectedEpisode((prev) => prev.map((x) => x._id === dataItem._id ? { ...x, [field]: onlyID ? selected._id : { _id: selected._id, Description: selected.Description } } : x));
        if (!updatedDataItemIds.includes(dataItem._id)) { setUpdatedDataItemIds((prev) => [...prev, dataItem._id]); }
    };

    const MyMultiSelectDropDown = (props) => {

        const field = props.field || '';
        let data = [];
        let onChange = (e) => { onMultiDropDownChange(e, props.dataItem, field) }
        let textField = "Description";

        if (field == "Genres" || field == "SubGenres") {
            data = genres;
        } else if (field == "Languages") {
            data = languages;
        } else if (field == "Categories") {
            data = categories;
            textField = "Name"
            onChange = (e) => { onMultiDropDownChange(e, props.dataItem, field, "Name") }
        } else {
            data = genres
        }

        return <DropdownCell {...props} data={data} onChange={onChange} textField={textField} />

    }

    const MySingleSelectDropDown = (props) => {

        const field = props.field || '';

        let data = [];
        let matchById = false;
        let textField = "Description";
        let onChange = (e) => {
            onDropDownChange(e, props.dataItem, field)
        }

        if (field == "Transmission") {
            data = Object.keys(MEDIA_TRANSMISSION).map((x) => ({ _id: MEDIA_TRANSMISSION[x], Description: x }))
            onChange = (e) => { onDropDownChange(e, props.dataItem, field, true) }
            matchById = true;
        } else if (field == "PGRating") {
            data = pgRatings
        }

        return <SingleDropDownCell {...props} data={data} onChange={onChange} matchById={matchById} textField={textField} />
    }

    //SYNC MAM ASSET 
    const onBrowseMamAsset = (datalist) => {
        console.log("BROWSE MAM");
        setSelectedEpisode(selectedEpisode.map(x => x._id == seletedEpisodeRef.current._id ? { ...x, MamID: datalist[0]?.RawData?.id?.toString() } : x));
        if (!updatedDataItemIds.includes(seletedEpisodeRef.current._id)) {
            setUpdatedDataItemIds([...updatedDataItemIds, seletedEpisodeRef.current._id]);
        }
    }

    const onSyncMAMAsset = async (mediaData) => {

        console.log(mediaData)

        if (!mediaData || mediaData.length == 0) return;

        let finalData = mediaData.map(x => ({ MamID: x.MamID, AssetId: x.AssetId }))

        const payload = { isSyncMultipleMedia: true, data: finalData, MamID: null, AssetId: null }

        console.log(payload)

        //CALL SYNC API HERE
        const reponse = await API.syncMediaManagement(payload)

        if (!reponse.success) {
            toast.error(reponse.message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }

        toast.success(reponse.message, {
            position: toast.POSITION.TOP_RIGHT
        });

    }

    const MamIDCell = (props) => {

        const field = props.field;
        const value = props?.dataItem?.[field] ?? '';

        return <td
            colSpan={props.colSpan}
            role={"gridcell"}
            aria-colindex={props.ariaColumnIndex}
            aria-selected={props.isSelected}
            {...{
                [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
            }}
            {...useTableKeyboardNavigation(props.id)}
            style={props.style}
        >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <input
                    type="text"
                    className="form-control form-control-sm"
                    name="MamID"
                    value={value}
                    onChange={() => { }}
                    disabled
                    required
                />

                <button placeholder="Attach MAM Asset" title="Attach MAM Asset" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                    style={{ height: "30px" }} onClick={() => { setShowMamAssetCollection(true); seletedEpisodeRef.current = props.dataItem }}><i className="fa-solid fa-ellipsis fa-xs"></i>
                </button>
                {/* <button placeholder="Sync MAM Asset" title="Sync MAM Asset" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
              style={{ height: "30px" }} onClick={onSyncMAMAsset}><i className="fa-solid fa-sync fa-xs"></i>
            </button> */}
                <button placeholder="Detach MAM Asset" title="Detach MAM Asset" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-error"
                    style={{ height: "30px" }} onClick={() => {
                        setSelectedEpisode(selectedEpisode.map(x => x._id == props.dataItem._id ? { ...x, MamID: "" } : x));
                        if (!updatedDataItemIds.includes(props.dataItem._id)) {
                            setUpdatedDataItemIds([...updatedDataItemIds, props.dataItem._id]);
                        }
                    }}><i className="fa-solid fa-xmark"></i>
                </button>
            </div>
        </td>
    }

    const onSelectionChange = (event) => {

        // ignore row click selection
        const fromCheckbox = event.syntheticEvent?.target?.closest?.('input[type="checkbox"]');
        if (!fromCheckbox) {
            event.preventDefault?.();
            return; 
        }
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedState(newSelectedState);

        let selectedIds = Object.keys(newSelectedState);
        let tempSelected = [];

        selectedIds.map((value) => {
            if (newSelectedState[value]) {
                let filter = selectedEpisode.find((obj) => obj._id == value);
                tempSelected.push(filter);
            }
        });
        seletedEpisodeRef.current = tempSelected;
        setUpdatedDataItemIds(tempSelected.map(x => x._id));
    };

    const onHeaderSelectionChange = (event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);

        var selectedIds = Object.keys(newSelectedState);
        var tempSelected = [];

        if (checked) {
            selectedIds.map((value) => {
                if (newSelectedState[value]) {
                    var filtered = selectedEpisode.find((obj) => obj._id == value);
                    tempSelected.push(filtered);
                }
            });
        }
        seletedEpisodeRef.current = tempSelected;
        setUpdatedDataItemIds(tempSelected.map(x => x._id));
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    }

    const handleUpdateAll = async () => {
        setIsEdit(true);
        if (seletedEpisodeRef.current.length == 0) {
            toast.success('Please select at least one episode', {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        let dataToUpdate = seletedEpisodeRef.current.map(d => {
            return {
                ...d,
                Title: (dataItem.Title && dataItem.Title != "") ? dataItem.Title : d.Title,
                EpisodeTitle: (dataItem.EpisodeTitle && dataItem.EpisodeTitle != "") ? dataItem.EpisodeTitle : d.EpisodeTitle,
                Duration: (dataItem.Duration && dataItem.Duration != "" && dataItem.Duration != "00:00:00:00") ? utility.convertStringWithFramesToMilliseconds(dataItem.Duration) : d.Duration,
                Genres: (dataItem.Genres && dataItem.Genres.length > 0) ? dataItem.Genres : d.Genres,
                SubGenres: (dataItem.SubGenres && dataItem.SubGenres.length > 0) ? dataItem.SubGenres : d.SubGenres,
                synopsis: (dataItem.Synopsis && dataItem.Synopsis != "") ? dataItem.Synopsis : d.synopsis,
            }
        });
        //Update grid data 
        const updatedSelectedEpisodes = selectedEpisode.map(original => {
            const updated = dataToUpdate.find(updatedItem => updatedItem._id === original._id);
            return updated ? updated : original;
        });
        seletedEpisodeRef.current = updatedSelectedEpisodes;
        setSelectedEpisode(updatedSelectedEpisodes);
        setSelectedState({});
        setDataItem(blankDataItem);
    }

    const onClose = () => {
        seletedEpisodeRef.current = [];
        setUpdatedDataItemIds([]);
        setSelectedState({});
        setDataItem(blankDataItem);
        setIsEdit(false);
        refresh();
        multipleUpdateFormClose();
    }

    return (
        <BossDialog title={'Update multiple'} onClose={() => isEdit ? ConfirmAlert(() => onClose(), () => { }, "Discard changes", "Are you sure you want to discard the changes?") : onClose()} width="90%" height="90%">
            <div className="flex-container">
                <div className='mt-2 mb-2'>
                    <EditPageHeader title={""} onSubmit={handleMultipleUpdateSave} onCancel={() => isEdit ? ConfirmAlert(() => onClose(), () => { }, "Discard changes", "Are you sure you want to discard the changes?") : onClose()} showTitle={false} />
                </div>
                <div className="flex-container-reverse flex-item-auto mt-2">
                    <PreferenceRoundButton
                        icon="gear"
                        title={lang.preference_button_tooltip}
                        onClick={() => { setShowPreferences(true) }}
                    />
                </div>
            </div>
            {seletedEpisodeRef.current.length > 1 && <div className='d-flex mb-3'>
                <div>
                    <label>{lang.title_label}</label><br />
                    <input style={{ width: "150px" }} type="text" name="Title" className="form-control form-control-sm" placeholder="Title" value={dataItem.Title} onChange={onChange} />
                </div>
                <div className='ml-2'>
                    <label>{lang.episode_title_label}</label><br />
                    <input style={{ width: "150px" }} type="text" name="EpisodeTitle" className="form-control form-control-sm" placeholder="EpisodeTitle" value={dataItem.EpisodeTitle} onChange={onChange} />
                </div>
                <div className='ml-2'>
                    <label>{lang.duration_without_format_label}</label><br />
                    <TimePickerWithFormat style={{ width: "120px" }} className="form-control form-control-sm" name="Duration" value={dataItem.Duration} onChange={onChange} />
                </div>
                <div className='ml-2'>
                    <label>{lang.geners_label}</label>
                    <MyMultiSelect
                        data={genres}
                        name="Genres"
                        dataItemKey="_id"
                        style={{ width: "200px" }}
                        textField="Description"
                        value={dataItem.Genres}
                        onChange={onChange}
                    />
                </div>
                <div className='ml-2'>
                    <label>{lang.sub_geners_label}</label>
                    <MyMultiSelect
                        data={genres}
                        name="SubGenres"
                        dataItemKey="_id"
                        style={{ width: "200px" }}
                        textField="Description"
                        value={dataItem.SubGenres}
                        onChange={onChange}
                    />
                </div>
                <div className='ml-2'>
                    <label>{lang.synopsis_label}</label><br />
                    <input style={{ width: "200px" }} type="text" name="Synopsis" className="form-control form-control-sm" placeholder="Synopsis" value={dataItem.Synopsis} onChange={onChange} />
                </div>
                <div className='ml-2' style={{ marginTop: "20px" }}>
                    <ActionButton btnColor="success" title={lang.update_all_button_tooltip} name={lang.update_all_button_text} onClick={handleUpdateAll} />
                </div>
            </div>}
            {isLoading ? <Loader /> :
                <Grid
                    data={
                        selectedEpisode.map((item) => ({
                            ...item,
                            [SELECTED_FIELD]: selectedState[idGetter(item)],
                        }))}
                    style={{ height: seletedEpisodeRef.current.length > 1 ? "75%" : "88%", width: "100%", overflow: "auto" }}
                    editField={EDIT_FIELD}
                    cellRender={customCellRender}
                    rowRender={customRowRender}
                    onItemChange={itemChange}
                    resizable={true}
                    onColumnResize={handleColumnResize}
                    selectedField={SELECTED_FIELD}
                    selectable={{
                        enabled: true,
                        drag: false,
                        cell: false,
                        mode: "multiple",
                    }}
                    dataItemKey={DATA_ITEM_KEY}
                    onSelectionChange={onSelectionChange}
                    onHeaderSelectionChange={onHeaderSelectionChange}
                >
                    <GridColumn
                        field={SELECTED_FIELD}
                        width="50px"
                        headerSelectionValue={
                            selectedEpisode.findIndex(
                                (item) => !selectedState[idGetter(item)]
                            ) === -1
                        }
                        locked={true}
                        filterable={false}
                    />
                    {dataColumns.map((column, index) => {
                        const titleWithIcon = column.editable ? (
                            <span>
                                {column.label} <Icon style={{ fontSize: '10px' }} name="pencil" />
                            </span>
                        ) : column.label;

                        if (column.type === COLUMNSTYPE.date) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={DateOnlyCell}
                                    title={titleWithIcon}
                                    width={column.width ?? 200}
                                    editable={column.editable}
                                />
                            );
                        } else if (column.type === COLUMNSTYPE.datetime) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={DateCell}
                                    title={titleWithIcon}
                                    width={column.width ?? 200}
                                    editable={column.editable}
                                />
                            );
                        }
                        else if (column.name.includes("Duration")) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={myTimeCellMilliseconds}
                                    title={titleWithIcon}
                                    width={column.width ?? 200}
                                    editable={column.editable}
                                />
                            );
                        } else if (column.name === "SID") {
                            return;
                        } else if (column.type === COLUMNSTYPE.image) {
                            return (
                                <GridColumn
                                    sortable={false}
                                    key={index}
                                    field={column.name}
                                    cell={ImageCell}
                                    title={titleWithIcon}
                                    width={column.width ?? 100}
                                    editable={column.editable}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.checkbox) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={CheckboxCell}
                                    title={titleWithIcon}
                                    width={column.width ?? 80}
                                    editable={column.editable}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.array) {
                            return (
                                <GridColumn
                                    sortable={false}
                                    key={index}
                                    field={column.name}
                                    cell={ArrayCell}
                                    title={titleWithIcon}
                                    width={column.width ?? 200}
                                    format={column.format ?? "Description"} //display item in object
                                    editable={column.editable}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.status) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={MyStatusCell}
                                    title={titleWithIcon}
                                    width={column.width ?? 200}
                                    editable={column.editable}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.localdatetime) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={LocalDateTimeColumn}
                                    title={titleWithIcon}
                                    width={column.width ?? 200}
                                    editable={column.editable}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.arrayenum) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={arrayEnumCell}
                                    title={titleWithIcon}
                                    width={column.width ?? 80}
                                    editable={column.editable}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.multiselectdropdown) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={(props) => <MyMultiSelectDropDown {...props} />}
                                    title={titleWithIcon}
                                    width={column.width ?? 80}
                                    editable={column.editable}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.singleselectdropdown) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={(props) => (<MySingleSelectDropDown {...props} />)}
                                    title={titleWithIcon}
                                    width={column.width ?? 80}
                                    editable={column.editable}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.mamIDCell) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={MamIDCell}
                                    title={titleWithIcon}
                                    width={column.width ?? 80}
                                    editable={column.editable}
                                />
                            );
                        }
                        else {
                            return (
                                column.type !== COLUMNSTYPE.hidden && (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        title={titleWithIcon}
                                        width={column.width ?? 200}
                                        editable={column.editable}
                                    />
                                )
                            );
                        }
                    })}
                </Grid>}


            {showPreferences && <UserPreference entityName={ENTITYNAME.MediaEpisodeMultiEdit} preferenceColumnENntityName={ENTITYNAME.MediaEpisodeMultiEdit} handleClose={() => { setShowPreferences(false); loadColumns(); }} />}
            {showMamAssetCollectionSelection && <CollectionSelection entityname={ENTITYNAME.MediaMamAssets} customColumns={MediaMamAssetColumns} title={lang.attach_mam_asset_tooltip} closeForm={() => setShowMamAssetCollection(false)} wherestatement={""} setDataList={onBrowseMamAsset} mode={"single"} width={"50vw"} />}

        </BossDialog>
    );
}

export default UpdateMultipleEpisodeDialog;